import React from 'react';
import Image from '../../assets/svg/panelImage.svg';
import Panel from '../../components/Panel';

const LoadingDefault = () => {
  return (
    <Panel
      panelType="loading"
      title="Só mais alguns segundos..."
      description={<>Parece que você já está logado, então iremos redirecionar você.</>}
      image={Image}
      className="loading-default-panel"
    />
  );
};

export default LoadingDefault;
